import { render } from "./BabylonExamples.vue?vue&type=template&id=6166df2b&scoped=true&ts=true"
import script from "./BabylonExamples.vue?vue&type=script&lang=ts"
export * from "./BabylonExamples.vue?vue&type=script&lang=ts"

import "./BabylonExamples.vue?vue&type=style&index=0&id=6166df2b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166df2b"]])

export default __exports__